import WishList from 'Vue/containers/WishList.vue';
import LockDesignerWishlist from 'Vue/containers/LockDesignerWishlist.vue';
import store from "Store/index";
import { createApp } from "vue";
import {lockDesignerStore} from "Store/lockDesignerStore";
import {falPlugin} from "Containers/fontAwesomeLibraryPlugin";
import Toast, {PluginOptions} from "vue-toastification";
import router from "Router/lockDesignerRoutes";

let module:any = {};

/**
 * Instantiate Vue Application
 */
module.wishListVueApp = function () {
	const sv = createApp(WishList).use(store);
	sv.mount("#wishList");
};

module.lockDesignerWishListVueApp = function () {
	const options: PluginOptions = {
		transition: 'Vue-Toastification__bounce',
		maxToasts: 20,
		newestOnTop: true,
	};
	const sv = createApp(LockDesignerWishlist).use(lockDesignerStore).use(falPlugin).use(Toast, options).use(router);
	sv.mount("#lockDesignerWishList");
};

module.init = function () {
	module.wishListVueApp();
	module.lockDesignerWishListVueApp();
};

document.addEventListener("DOMContentLoaded", () => {
	module.init();
});
